export const loaderContainer: CSSFunction = ({ cssProps }) => ({
  pointerEvents: cssProps.loading ? 'none' : 'auto',
  alignItems: 'center',
  justifyContent: 'center',
  width: '90%',
});
